export default "__VITE_ASSET__D1HV5l$j__"